/**
 * Taktgeber zwischen Nav-Morph (SiteNav: Balken ↔ Pill) und dem Logo-Dock im
 * Hero. Beide reagieren aufs Runterscrollen — liefen sie unabhängig, flöge
 * das Logo in eine Navbar, die gerade schrumpft. Deshalb:
 *
 *  - SiteNav stellt ihren Morph hier bereit (`provideNav`).
 *  - Steht ein Hero-Logo auf der Seite, beansprucht der Logo-Dock den Morph
 *    (`claim`) und taktet ihn selbst: erst Logo rein, dann Nav klein.
 *  - Ohne Anspruch morpht die Nav an ihrem eigenen Scroll-Schwellwert;
 *    gibt der Hero den Anspruch ab, gleicht sie sich daran wieder an.
 *
 * Bewusst Modul-Zustand statt Vue-State: genutzt wird er nur im Client
 * (onMounted), und es gibt genau eine Nav.
 */

export interface NavMorph {
  setCompact: (compact: boolean, animate?: boolean) => void
  isCompact: () => boolean
  /** Zurück auf den eigenen Scroll-Schwellwert (ohne Animation) */
  sync: () => void
}

/** Dauer des Flip-Morphs Balken ↔ Pill in Sekunden */
export const NAV_MORPH_DURATION = 0.5

let nav: NavMorph | undefined
let claims = 0

export function useNavDock() {
  return {
    provideNav(api: NavMorph) {
      nav = api
      return () => {
        if (nav === api) nav = undefined
      }
    },
    claim() {
      claims++
      let released = false
      return () => {
        if (released) return
        released = true
        claims--
        if (!claims) nav?.sync()
      }
    },
    isClaimed: () => claims > 0,
    nav: () => nav
  }
}
